import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    IconButton, TextField, Box
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { useState } from "react";

const EditableTestExecutionTable = ({ data, onChange }) => {
    const [editableData, setEditableData] = useState([...data]);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [originalData, setOriginalData] = useState([]);

    const handleRowEdit = (index) => {
        if (index === null) {
            // Save
            setEditingRowIndex(null);
            // Update parent or context if needed
        } else {
            setOriginalData([...editableData]);
            setEditingRowIndex(index);
        }
    };

    const handleCancel = () => {
        setEditableData([...originalData]);
        setEditingRowIndex(null);
    };

    const handleChange = (index, key, value) => {
        const updated = [...editableData];
        updated[index][key] = value;
        setEditableData(updated);
    };

    const handleEditClick = (index) => {
        setEditingRowIndex(index);
    };

    const handleSaveClick = () => {
        setEditingRowIndex(null);
        onChange && onChange(editableData);
    };

    const handleCancelClick = () => {
        setEditingRowIndex(null);
        setEditableData([...data]);
    };

    // const handleChange = (index, key, value) => {
    //     const updatedData = [...editableData];
    //     updatedData[index][key] = value;
    //     setEditableData(updatedData);
    // };

    const headers = Object.keys(data[0] || {});

    return (
        <TableContainer
            sx={{
                border: '1px solid #ddd',
                maxHeight: '400px',
                overflowX: 'auto',
                scrollbarWidth: 'thin',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
        >
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        {headers.map((key) => (
                            <TableCell
                                key={key}
                                sx={{
                                    backgroundColor: '#2196F3',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    whiteSpace: 'nowrap',
                                    borderRight: '1px solid #e0e0e0',
                                    textAlign: 'left',
                                }}
                            >
                                {key}
                            </TableCell>
                        ))}
                        <TableCell
                            sx={{
                                backgroundColor: '#2196F3',
                                color: 'white',
                                fontWeight: 'bold',
                                textAlign: 'center',
                            }}
                        >
                            Action
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {editableData.map((row, index) => (
                        <TableRow key={index}>
                            {headers.map((key) => (
                                <TableCell
                                    key={key}
                                    sx={{ borderRight: '1px solid #e0e0e0', whiteSpace: 'nowrap' }}
                                >
                                    {editingRowIndex === index ? (
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            value={row[key]}
                                            onChange={(e) => handleChange(index, key, e.target.value)}
                                            InputProps={{
                                                sx: {
                                                    fontSize: '16px',
                                                    padding: '0px',
                                                    height: '100%',         // makes sure it matches the row height
                                                    backgroundColor: 'white',
                                                },
                                                style: {
                                                    fontSize: '16px',
                                                    padding: '0px',
                                                }
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '0 8px',        // mimic cell spacing
                                                    fontSize: '16px',
                                                    minHeight: 'auto',
                                                },
                                                '& .MuiOutlinedInput-input': {
                                                    padding: '4px 0px',
                                                },
                                            }}
                                        />


                                    ) : (
                                        row[key]
                                    )}
                                </TableCell>
                            ))}
                            <TableCell>
                                {editingRowIndex === index ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', color: '#2196f3', cursor: 'pointer' }}>
                                        <span onClick={() => handleRowEdit(null)}>Save</span>
                                        <span onClick={handleCancel}>Cancel</span>
                                    </div>
                                ) : (
                                    <EditIcon
                                        style={{ color: '#2196f3', cursor: 'pointer' }}
                                        onClick={() => handleRowEdit(index)}
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

    );
};

export default EditableTestExecutionTable;
